import { render, staticRenderFns } from "./labelOperation.vue?vue&type=template&id=4af4271f&scoped=true&"
import script from "./labelOperation.vue?vue&type=script&lang=ts&"
export * from "./labelOperation.vue?vue&type=script&lang=ts&"
import style0 from "./labelOperation.vue?vue&type=style&index=0&id=4af4271f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af4271f",
  null
  
)

export default component.exports